import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "requisites" }
const _hoisted_2 = {
  key: 0,
  class: "requisites__container"
}
const _hoisted_3 = { class: "requisites__block" }
const _hoisted_4 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_5 = { class: "requisites__content" }
const _hoisted_6 = {
  key: 1,
  class: "requisites__container"
}
const _hoisted_7 = { class: "requisites__block" }
const _hoisted_8 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_9 = { class: "requisites__content" }
const _hoisted_10 = { class: "requisites__container" }
const _hoisted_11 = { class: "requisites__block requisites__block--switcher" }
const _hoisted_12 = { class: "requisites__label text-capitalize-first" }
const _hoisted_13 = { class: "requisites__content requisites__content__switch" }
const _hoisted_14 = { class: "switch" }
const _hoisted_15 = { class: "requisites__container" }
const _hoisted_16 = { class: "requisites__block" }
const _hoisted_17 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_18 = { class: "requisites__content" }
const _hoisted_19 = { class: "requisites__block" }
const _hoisted_20 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_21 = { class: "requisites__content" }
const _hoisted_22 = {
  key: 0,
  class: "requisites__block"
}
const _hoisted_23 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_24 = { class: "requisites__content" }
const _hoisted_25 = {
  key: 1,
  class: "requisites__container"
}
const _hoisted_26 = {
  key: 0,
  class: "requisites__block"
}
const _hoisted_27 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_28 = { class: "requisites__content" }
const _hoisted_29 = { class: "radio-list" }
const _hoisted_30 = { class: "radio" }
const _hoisted_31 = { for: "vietQrModeAuto" }
const _hoisted_32 = { class: "radio" }
const _hoisted_33 = { for: "vietQrModeUpload" }
const _hoisted_34 = { class: "requisites__block" }
const _hoisted_35 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_36 = { class: "requisites__content" }
const _hoisted_37 = { class: "radio-list" }
const _hoisted_38 = { class: "radio" }
const _hoisted_39 = { for: "vietQrDynamic" }
const _hoisted_40 = { class: "radio" }
const _hoisted_41 = { for: "vietQrStatic" }
const _hoisted_42 = {
  key: 2,
  class: "requisites__container"
}
const _hoisted_43 = { class: "requisites__block" }
const _hoisted_44 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_45 = { class: "requisites__content" }
const _hoisted_46 = { class: "radio-list" }
const _hoisted_47 = { class: "radio" }
const _hoisted_48 = { for: "qrisDynamic" }
const _hoisted_49 = { class: "radio" }
const _hoisted_50 = { for: "qrisStatic" }
const _hoisted_51 = {
  key: 3,
  class: "requisites__container"
}
const _hoisted_52 = { class: "requisites__block" }
const _hoisted_53 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_54 = { class: "requisites__content" }
const _hoisted_55 = { class: "radio-list" }
const _hoisted_56 = { class: "radio" }
const _hoisted_57 = ["checked"]
const _hoisted_58 = { for: "pixDynamic" }
const _hoisted_59 = { class: "radio" }
const _hoisted_60 = ["checked"]
const _hoisted_61 = { for: "pixStatic" }
const _hoisted_62 = { class: "requisites__block" }
const _hoisted_63 = { class: "requisites__content" }
const _hoisted_64 = { class: "pay-method" }
const _hoisted_65 = { class: "pay-method" }
const _hoisted_66 = {
  key: 4,
  class: "requisites__block"
}
const _hoisted_67 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_68 = { class: "requisites__content" }
const _hoisted_69 = {
  key: 5,
  class: "requisites__block"
}
const _hoisted_70 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_71 = { class: "requisites__content" }
const _hoisted_72 = ["placeholder", "data-maska", "data-maska-tokens"]
const _hoisted_73 = {
  key: 6,
  class: "requisites__block"
}
const _hoisted_74 = { class: "requisites__content" }
const _hoisted_75 = { class: "text-muted" }
const _hoisted_76 = {
  key: 7,
  class: "requisites__block"
}
const _hoisted_77 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_78 = {
  key: 0,
  class: "text-muted fw-normal"
}
const _hoisted_79 = { class: "requisites__content" }
const _hoisted_80 = {
  key: 8,
  class: "requisites__block"
}
const _hoisted_81 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_82 = { class: "text-muted fw-normal" }
const _hoisted_83 = { class: "requisites__content" }
const _hoisted_84 = {
  key: 9,
  class: "requisites__block"
}
const _hoisted_85 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_86 = { class: "requisites__content" }
const _hoisted_87 = ["data-maska", "data-maska-tokens"]
const _hoisted_88 = {
  key: 2,
  class: "requisites__container"
}
const _hoisted_89 = { class: "requisites__block" }
const _hoisted_90 = { class: "requisites__content" }
const _hoisted_91 = { class: "text-muted" }
const _hoisted_92 = {
  key: 3,
  class: "requisites__container"
}
const _hoisted_93 = { class: "requisites__block" }
const _hoisted_94 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_95 = { class: "requisites__content" }
const _hoisted_96 = ["onUpdate:modelValue", "id"]
const _hoisted_97 = ["onUpdate:modelValue", "id"]
const _hoisted_98 = {
  key: 4,
  class: "requisites__container"
}
const _hoisted_99 = { class: "requisites__block" }
const _hoisted_100 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_101 = { class: "requisites__content" }
const _hoisted_102 = ["readonly", "onUpdate:modelValue", "id"]
const _hoisted_103 = ["readonly", "onUpdate:modelValue", "id"]
const _hoisted_104 = { class: "requisites__container" }
const _hoisted_105 = { class: "requisites__block" }
const _hoisted_106 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_107 = { class: "requisites__content" }
const _hoisted_108 = { class: "requisites__block" }
const _hoisted_109 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_110 = { class: "requisites__content" }
const _hoisted_111 = { class: "requisites__container requisites__container--row" }
const _hoisted_112 = { class: "requisites__block requisites__block--50 align-items-start" }
const _hoisted_113 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_114 = ["title"]
const _hoisted_115 = { class: "requisites__content" }
const _hoisted_116 = ["readonly", "title"]
const _hoisted_117 = { key: 1 }
const _hoisted_118 = {
  for: "multiplesOfValue",
  class: "text-capitalize-first"
}
const _hoisted_119 = { class: "requisites__block requisites__block--50 align-items-start" }
const _hoisted_120 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_121 = { class: "requisites__content" }
const _hoisted_122 = ["readonly"]
const _hoisted_123 = { class: "requisites__block requisites__block--50" }
const _hoisted_124 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_125 = { class: "requisites__content gap-2" }
const _hoisted_126 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_127 = { class: "requisites__block requisites__block--50" }
const _hoisted_128 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_129 = { class: "requisites__content gap-2" }
const _hoisted_130 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_131 = { class: "requisites__block requisites__block--50" }
const _hoisted_132 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_133 = { class: "requisites__content gap-2" }
const _hoisted_134 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_135 = { class: "requisites__block requisites__block--50" }
const _hoisted_136 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_137 = { class: "requisites__content gap-2" }
const _hoisted_138 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_139 = {
  key: 0,
  class: "requisites__block requisites__block--50"
}
const _hoisted_140 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_141 = { class: "requisites__content gap-2" }
const _hoisted_142 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_143 = {
  key: 1,
  class: "requisites__block requisites__block--50"
}
const _hoisted_144 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_145 = { class: "requisites__content gap-2" }
const _hoisted_146 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_147 = {
  key: 2,
  class: "requisites__block requisites__block--50--all justify-content-end"
}
const _hoisted_148 = { class: "text-capitalize-first" }
const _hoisted_149 = {
  key: 3,
  class: "requisites__block requisites__block--50--all justify-content-end"
}
const _hoisted_150 = { class: "text-capitalize-first" }
const _hoisted_151 = {
  key: 4,
  class: "requisites__block requisites__block--50--all justify-content-end requisites__block--right"
}
const _hoisted_152 = { class: "requisites__current-count flex-0_5" }
const _hoisted_153 = { class: "requisites__block requisites__block--50" }
const _hoisted_154 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_155 = { class: "requisites__content gap-2" }
const _hoisted_156 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_157 = { class: "requisites__block requisites__block--50" }
const _hoisted_158 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_159 = { class: "requisites__content gap-2" }
const _hoisted_160 = {
  key: 0,
  class: "requisites__current-count"
}
const _hoisted_161 = { class: "requisites__block requisites__block--50 requisites__block--switcher" }
const _hoisted_162 = { class: "requisites__label text-capitalize-first" }
const _hoisted_163 = { class: "requisites__content requisites__content__switch" }
const _hoisted_164 = { class: "switch" }
const _hoisted_165 = {
  key: 0,
  class: "requisites__block requisites__block--50--all justify-content-end"
}
const _hoisted_166 = { class: "text-capitalize-first" }
const _hoisted_167 = { class: "requisites__container requisites__container--row" }
const _hoisted_168 = {
  key: 0,
  class: "requisites__block requisites__block--50"
}
const _hoisted_169 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_170 = { class: "requisites__content" }
const _hoisted_171 = {
  key: 1,
  class: "requisites__block requisites__block--50"
}
const _hoisted_172 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_173 = { class: "requisites__content" }
const _hoisted_174 = {
  key: 2,
  class: "requisites__block requisites__block--50"
}
const _hoisted_175 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_176 = { class: "requisites__content" }
const _hoisted_177 = ["value"]
const _hoisted_178 = {
  key: 3,
  class: "requisites__block requisites__block--100"
}
const _hoisted_179 = { class: "requisites__content" }
const _hoisted_180 = { class: "requisites__container requisites__container--row" }
const _hoisted_181 = { class: "requisites__block requisites__block--50 requisites__block--switcher" }
const _hoisted_182 = { class: "requisites__label text-capitalize-first" }
const _hoisted_183 = { class: "requisites__content requisites__content__switch" }
const _hoisted_184 = { class: "switch" }
const _hoisted_185 = { class: "requisites__container requisites__container--row" }
const _hoisted_186 = { class: "requisites__block requisites__block--50 requisites__block--switcher" }
const _hoisted_187 = { class: "requisites__label text-capitalize-first" }
const _hoisted_188 = { class: "requisites__content requisites__content__switch" }
const _hoisted_189 = { class: "switch" }
const _hoisted_190 = {
  key: 0,
  class: "requisites__block requisites__block--50 requisites__block--switcher"
}
const _hoisted_191 = { class: "requisites__label text-capitalize-first" }
const _hoisted_192 = { class: "requisites__content requisites__content__switch" }
const _hoisted_193 = { class: "switch" }
const _hoisted_194 = {
  key: 5,
  class: "requisites__container requisites__container--row"
}
const _hoisted_195 = {
  key: 0,
  class: "requisites__block requisites__block--50"
}
const _hoisted_196 = { class: "requisites__label requisites__label--start" }
const _hoisted_197 = { class: "requisites__content" }
const _hoisted_198 = {
  key: 1,
  class: "requisites__block requisites__block--50"
}
const _hoisted_199 = { class: "requisites__label requisites__label--start" }
const _hoisted_200 = { class: "requisites__content" }
const _hoisted_201 = {
  key: 6,
  class: "requisites__container"
}
const _hoisted_202 = { class: "" }
const _hoisted_203 = {
  class: "",
  for: "isAgreeBlacklistPaymentMethod"
}
const _hoisted_204 = { class: "requisites__controls" }
const _hoisted_205 = { class: "text-capitalize-first" }
const _hoisted_206 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DropzoneInput = _resolveComponent("DropzoneInput")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_FraudexCheckPopup = _resolveComponent("FraudexCheckPopup")!
  const _directive_maska = _resolveDirective("maska")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Popup, {
      ref: (el) => _ctx.popup = el,
      class: "popup__lg",
      title: _ctx.popupTitle,
      onOnClose: _ctx.hide
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_1, [
          (_ctx.templateMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("requisites.templates.name")), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "name",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.templateName) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          maxlength: "255",
                          id: "templateName"
                        }, null, 2), [
                          [_vModelText, _ctx.templateName]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.templateSelectVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("requisites.templates.select_label")), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Multiselect, {
                      id: "requisiteTemplate",
                      modelValue: _ctx.selectedTemplate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
                      options: _ctx.templates,
                      label: "name",
                      "track-by": "id",
                      multiple: false,
                      "select-label": "Select",
                      placeholder: _ctx.$t('requisites.templates.select_placeholder'),
                      onSelect: _ctx.applyTemplate,
                      onRemove: _ctx.clearTemplate
                    }, null, 8, ["modelValue", "options", "placeholder", "onSelect", "onRemove"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.form.isActive ? _ctx.$t('requisites.active') : _ctx.$t('requisites.inactive')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.isActive) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isActive]
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "slider" }, null, -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("labels.currency")), 1),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FormInputWrapper, {
                  field: "currency",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "currency",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.currency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.currency) = $event)),
                      options: _ctx.store.getters['currencyMethods/currencies'],
                      "custom-label": (opt) => `${opt}`,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("labels.payment_option")), 1),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_FormInputWrapper, {
                  field: "paymentOption",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "paymentOption",
                      disabled: !_ctx.form.currency,
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.paymentOption,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.paymentOption) = $event)),
                      options: _ctx.store.getters['currencyMethods/options'](_ctx.form.currency),
                      "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["disabled", "modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                })
              ])
            ]),
            ([_ctx.PaymentOption.CROSS_BORDER, _ctx.PaymentOption.MOBILE_TOP_UP, _ctx.PaymentOption.SBP_QR, _ctx.PaymentOption.CARD_ACQUIRING_REDIRECT].includes(_ctx.form.paymentOption))
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("labels.crossBorderCurrency")), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "crossBorderCurrency",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _createVNode(_component_Multiselect, {
                          id: "currency",
                          class: _normalizeClass(["", parentProps.class]),
                          modelValue: _ctx.form.crossBorderCurrency,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.crossBorderCurrency) = $event)),
                          options: _ctx.store.getters['currencyMethods/crossBorderCurrencies'],
                          "custom-label": (opt) => `${opt}`,
                          multiple: false,
                          "select-label": "Select",
                          placeholder: ""
                        }, null, 8, ["modelValue", "options", "custom-label", "class"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVietQr)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (!_ctx.templateMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("labels.viet_qr_input_mode")), 1),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vietQrInputMode) = $event)),
                                value: "auto",
                                type: "radio",
                                name: "vietQrInputMode",
                                id: "vietQrModeAuto"
                              }, null, 512), [
                                [_vModelRadio, _ctx.vietQrInputMode]
                              ]),
                              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('labels.viet_qr_mode_auto')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vietQrInputMode) = $event)),
                                value: "upload",
                                type: "radio",
                                name: "vietQrInputMode",
                                id: "vietQrModeUpload"
                              }, null, 512), [
                                [_vModelRadio, _ctx.vietQrInputMode]
                              ]),
                              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('labels.viet_qr_mode_upload')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("labels.viet_qr_type")), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.vietQrIsStatic) = $event)),
                            value: false,
                            type: "radio",
                            name: "vietQrIsStatic",
                            id: "vietQrDynamic"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.vietQrIsStatic]
                          ]),
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('labels.viet_qr_dynamic')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.vietQrIsStatic) = $event)),
                            value: true,
                            type: "radio",
                            name: "vietQrIsStatic",
                            id: "vietQrStatic"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.vietQrIsStatic]
                          ]),
                          _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('labels.viet_qr_static')), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isIndQr)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("labels.qris_type")), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.qrisIsStatic) = $event)),
                            value: false,
                            type: "radio",
                            name: "qrisIsStatic",
                            id: "qrisDynamic"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.qrisIsStatic]
                          ]),
                          _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('labels.qris_dynamic')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.qrisIsStatic) = $event)),
                            value: true,
                            type: "radio",
                            name: "qrisIsStatic",
                            id: "qrisStatic"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.qrisIsStatic]
                          ]),
                          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('labels.qris_static')), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isBrQr)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t("labels.pix_type")), 1),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("input", {
                            checked: _ctx.form.pixIsStatic !== true,
                            type: "radio",
                            name: "pixIsStatic",
                            id: "pixDynamic",
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.pixIsStatic = false))
                          }, null, 40, _hoisted_57),
                          _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('labels.pix_dynamic')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("input", {
                            checked: _ctx.form.pixIsStatic === true,
                            type: "radio",
                            name: "pixIsStatic",
                            id: "pixStatic",
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.pixIsStatic = true))
                          }, null, 40, _hoisted_60),
                          _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('labels.pix_static')), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_62, [
              _cache[47] || (_cache[47] = _createElementVNode("div", { class: "requisites__label requisites__label--start text-capitalize-first" }, null, -1)),
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_FormInputWrapper, {
                  field: "method",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "method",
                      disabled: !_ctx.form.paymentOption || !_ctx.paymentOptionCurrency,
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.method,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.method) = $event)),
                      options: _ctx.methodOptions,
                      "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, {
                      option: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_PayMethodIcon, {
                            "icon-class": "icon",
                            method: props.option
                          }, null, 8, ["method"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                        ])
                      ]),
                      singleLabel: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_PayMethodIcon, {
                            "icon-class": "icon",
                            method: props.option
                          }, null, 8, ["method"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["disabled", "modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.form.currency && _ctx.form.paymentOption && _ctx.form.method && _ctx.store.getters['currencyMethods/paymentSystems'](_ctx.form.currency, _ctx.form.paymentOption).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("labels.payment_system")), 1),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "paymentSystem",
                      form: "paymentSystem"
                    }, {
                      default: _withCtx((parentProps) => [
                        _createVNode(_component_Multiselect, {
                          id: "paymentSystem",
                          class: _normalizeClass(["", parentProps.class]),
                          modelValue: _ctx.form.paymentSystem,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.paymentSystem) = $event)),
                          options: _ctx.store.getters['currencyMethods/paymentSystems'](_ctx.form.currency, _ctx.form.paymentOption),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_systems.${opt}`),
                          multiple: false,
                          "select-label": "Select",
                          placeholder: ""
                        }, null, 8, ["modelValue", "options", "custom-label", "class"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.templateMode && _ctx.form.paymentOption !== _ctx.PaymentOption.VIET_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.IND_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.BR_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.MANUAL_SBP_QR)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.requisiteFieldLabel), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "requisites",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.requisites) = $event)),
                          placeholder: _ctx.requisitesMaskaPlaceholder,
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": _ctx.requisitesMaskaOptions.pattern,
                          "data-maska-tokens": _ctx.requisitesMaskaOptions.tokens,
                          type: "text",
                          id: "requisites"
                        }, null, 10, _hoisted_72), [
                          [_vModelText, _ctx.form.requisites],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.templateMode && _ctx.form.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.form.method === _ctx.PaymentMethod.qr_manager)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "requisites__label" }, null, -1)),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("small", _hoisted_75, _toDisplayString(_ctx.$t('qr_manager.requisites_hint')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isHolderNameVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.holder_name")) + " ", 1),
                    (_ctx.isIndQr || _ctx.isBrQr)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_78, "(" + _toDisplayString(_ctx.$t('labels.optional_field')) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "holderName",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.holderName) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "holderName"
                        }, null, 2), [
                          [_vModelText, _ctx.form.holderName]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.paymentOption === _ctx.PaymentOption.CROSS_BORDER)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.raw_field.swift")) + " ", 1),
                    _createElementVNode("small", _hoisted_82, "(" + _toDisplayString(_ctx.$t('labels.optional_field')) + ")", 1)
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "raw.swift",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.raw.swift) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "crossBorderSwift"
                        }, null, 2), [
                          [_vModelText, _ctx.form.raw.swift]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAccountNumberVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t("labels.account_number")), 1),
                  _createElementVNode("div", _hoisted_86, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "accountNumber",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.accountNumber) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": _ctx.isVietQrAutoMode ? '9' : null,
                          "data-maska-tokens": _ctx.isVietQrAutoMode ? '9:[0-9]:repeated' : null,
                          type: "text",
                          id: "accountNumber"
                        }, null, 10, _hoisted_87), [
                          [_vModelText, _ctx.form.accountNumber],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.form.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.form.method === _ctx.PaymentMethod.qr_manager && _ctx.additionalFields.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "requisites__label" }, null, -1)),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("small", _hoisted_91, _toDisplayString(_ctx.$t('qr_manager.p2c_credentials_intro')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.additionalFields.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalFields, (field) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.$t(`labels.additional_field.${field.name}`)), 1),
                    _createElementVNode("div", _hoisted_95, [
                      _createVNode(_component_FormInputWrapper, {
                        field: `additional_field_${field.name}`,
                        form: "requisitesForm"
                      }, {
                        default: _withCtx((parentProps) => [
                          (field.type === 'input')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                                class: _normalizeClass([parentProps.class, "form-control"]),
                                type: "text",
                                id: `additional_field_${field.name}`
                              }, null, 10, _hoisted_96)), [
                                [_vModelText, _ctx.form.p2cConfig[field.name]]
                              ])
                            : _createCommentVNode("", true),
                          (field.type === 'textarea')
                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 1,
                                rows: "5",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                                class: _normalizeClass([parentProps.class, "form-control"]),
                                type: "text",
                                id: `additional_field_${field.name}`
                              }, null, 10, _hoisted_97)), [
                                [_vModelText, _ctx.form.p2cConfig[field.name]]
                              ])
                            : _createCommentVNode("", true),
                          (field.type === 'dropdown')
                            ? (_openBlock(), _createBlock(_component_Multiselect, {
                                key: 2,
                                class: _normalizeClass(parentProps.class),
                                id: `additional_field_${field.name}`,
                                modelValue: _ctx.form.p2cConfig[field.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                                options: field.values,
                                "custom-label": (opt) => field.customLabel(opt),
                                multiple: false,
                                "select-label": "Select",
                                placeholder: ""
                              }, null, 8, ["class", "id", "modelValue", "onUpdate:modelValue", "options", "custom-label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["field"])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_ctx.rawFields.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawFields, (field) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t(`labels.raw_field.${field.name}`,{}, field.name)), 1),
                    _createElementVNode("div", _hoisted_101, [
                      _createVNode(_component_FormInputWrapper, {
                        field: `raw_field_${field.name}`,
                        form: "requisitesForm"
                      }, {
                        default: _withCtx((parentProps) => [
                          (field.type === 'input')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                readonly: field.readonly ?? false,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.raw[field.name]) = $event),
                                class: _normalizeClass([parentProps.class, "form-control"]),
                                type: "text",
                                id: `raw_field_${field.name}`
                              }, null, 10, _hoisted_102)), [
                                [_vModelText, _ctx.form.raw[field.name]]
                              ])
                            : _createCommentVNode("", true),
                          (field.type === 'textarea')
                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 1,
                                readonly: field.readonly ?? false,
                                rows: "5",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.form.raw[field.name]) = $event),
                                class: _normalizeClass([parentProps.class, "form-control"]),
                                type: "text",
                                id: `raw_field_${field.name}`
                              }, null, 10, _hoisted_103)), [
                                [_vModelText, _ctx.form.raw[field.name]]
                              ])
                            : _createCommentVNode("", true),
                          (field.type === 'dropzone')
                            ? (_openBlock(), _createBlock(_component_DropzoneInput, {
                                key: 2,
                                options: {accept:['.jpg', '.png', '.jpeg'], multiple: false, maxFiles: 1},
                                onChange: field.dropzone?.onChange,
                                label: field.label
                              }, null, 8, ["onChange", "label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["field"])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t('labels.req_group')), 1),
              _createElementVNode("div", _hoisted_107, [
                _createVNode(_component_FormInputWrapper, {
                  field: "groupId",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "group",
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.groupId,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.groupId) = $event)),
                      options: _ctx.store.getters['reqGroups/ids'],
                      "custom-label": (opt) => _ctx.store.getters['reqGroups/get'](opt)?.name,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["class", "modelValue", "options", "custom-label"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$t('labels.device')), 1),
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_FormInputWrapper, {
                  field: "deviceId",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "device",
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.deviceId,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.deviceId) = $event)),
                      options: _ctx.store.getters['devices/ids'],
                      "custom-label": (opt) => _ctx.store.getters['devices/get'](opt)?.name,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["class", "modelValue", "options", "custom-label"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.min_pay_in_deal_sum")) + " ", 1),
                (_ctx.isLimitsBlocked && _ctx.form.id)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fa fa-question-circle text-info ms-2",
                      title: _ctx.$t('labels.limits_blocked_by_plan'),
                      style: {"cursor":"help"}
                    }, null, 8, _hoisted_114))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_115, [
                _createVNode(_component_FormInputWrapper, {
                  field: "minPayInDealSum",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.minPayInDealSum) = $event)),
                      readonly: !_ctx.form.payInDealSumsEditable || _ctx.isLimitsBlocked,
                      class: _normalizeClass([[parentProps.class, { 'form-control--disabled': _ctx.isLimitsBlocked, 'form-control--danger': _ctx.form.id && _ctx.isLimitsBlocked, 'form-control--success': _ctx.form.id && !_ctx.isLimitsBlocked }], "form-control"]),
                      title: _ctx.isLimitsBlocked && _ctx.form.id ? _ctx.$t('labels.limits_blocked_by_plan') : null,
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "minPayInDealSum"
                    }, null, 10, _hoisted_116), [
                      [_vModelText, _ctx.form.minPayInDealSum],
                      [_directive_maska],
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.reuseCapEvaluation.status !== 'ok')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["small mt-1", _ctx.reuseCapEvaluation.status === 'blocked' ? 'reuse-cap--blocked' : 'reuse-cap--partial'])
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.reuseCapEvaluation.status === 'blocked' ? _ctx.$t('labels.reuse_cap_blocked') : _ctx.$t('labels.reuse_cap_partial')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reuseCapEvaluation.blockedGroups, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `blocked-${group.groupId}`
                        }, _toDisplayString(_ctx.$t('labels.reuse_cap_group_blocked', {group: group.name ?? _ctx.$t('labels.reuse_cap_hidden_group'), cap: group.looseCap ?? group.strictCap, currency: _ctx.form.currency})), 1))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reuseCapEvaluation.partialGroups, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `partial-${group.groupId}`
                        }, _toDisplayString(_ctx.$t('labels.reuse_cap_group_partial', {group: group.name ?? _ctx.$t('labels.reuse_cap_hidden_group'), cap: group.strictCap, currency: _ctx.form.currency})), 1))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.store.getters.getAppData?.payInMultiplesEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t('labels.multiples_of_value')), 1),
                      _createVNode(_component_FormInputWrapper, {
                        field: "multiplesOfValue",
                        form: "requisitesForm"
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.multiplesOfValue) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "data-maska": "9 99#",
                            "data-maska-tokens": "9:[0-9]:repeated",
                            "data-maska-reversed": "",
                            type: "text",
                            id: "multiplesOfValue"
                          }, null, 2), [
                            [_vModelText, _ctx.form.multiplesOfValue],
                            [_directive_maska]
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.$t("labels.max_pay_in_deal_sum")), 1),
              _createElementVNode("div", _hoisted_121, [
                _createVNode(_component_FormInputWrapper, {
                  field: "maxPayInDealSum",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.maxPayInDealSum) = $event)),
                      readonly: !_ctx.form.payInDealSumsEditable,
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "maxPayInDealSum"
                    }, null, 10, _hoisted_122), [
                      [_vModelText, _ctx.form.maxPayInDealSum],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.$t("labels.daily_sum")), 1),
              _createElementVNode("div", _hoisted_125, [
                _createVNode(_component_FormInputWrapper, {
                  field: "dayTradesSumLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.dayTradesSumLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "dayTradesSumLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.dayTradesSumLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.form.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.dayTradesSum)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t("labels.monthly_sum")), 1),
              _createElementVNode("div", _hoisted_129, [
                _createVNode(_component_FormInputWrapper, {
                  field: "monthTradesSumLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.monthTradesSumLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "monthTradesSumLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.monthTradesSumLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.form.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.monthTradesSum)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t("labels.daily_qty")), 1),
              _createElementVNode("div", _hoisted_133, [
                _createVNode(_component_FormInputWrapper, {
                  field: "dayTradesCountLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.dayTradesCountLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "dayTradesCountLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.dayTradesCountLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.form.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.dayTradesCount)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.$t("labels.monthly_qty")), 1),
              _createElementVNode("div", _hoisted_137, [
                _createVNode(_component_FormInputWrapper, {
                  field: "monthTradesCountLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.monthTradesCountLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "monthTradesCountLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.monthTradesCountLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.form.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.monthTradesCount)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.$t("labels.daily_qty_all_deals")), 1),
                  _createElementVNode("div", _hoisted_141, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "dayTradesAllCountLimit",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.dayTradesAllCountLimit) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": "",
                          type: "text",
                          required: "",
                          id: "dayTradesAllCountLimit"
                        }, null, 2), [
                          [_vModelText, _ctx.form.dayTradesAllCountLimit],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.form.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_142, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.dayTradesAllCount)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                  _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.$t("labels.monthly_qty_all_deals")), 1),
                  _createElementVNode("div", _hoisted_145, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "monthTradesAllCountLimit",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.monthTradesAllCountLimit) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": "",
                          type: "text",
                          required: "",
                          id: "monthTradesAllCountLimit"
                        }, null, 2), [
                          [_vModelText, _ctx.form.monthTradesAllCountLimit],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.form.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.monthTradesAllCount)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                  _createVNode(_component_LoaderButton, {
                    "on-click": () => _ctx.resetLimits('day'),
                    class: "btn btn-outline-primary btn-sm flex-0_5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.$t('button.reset_day_limit')), 1)
                    ]),
                    _: 1
                  }, 8, ["on-click"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                  _createVNode(_component_LoaderButton, {
                    "on-click": () => _ctx.resetLimits('month'),
                    class: "btn btn-outline-primary btn-sm flex-0_5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.$t('button.reset_month_limit')), 1)
                    ]),
                    _: 1
                  }, 8, ["on-click"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.monthLimitNextResetDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                  _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.$t("labels.next_reset")) + ": " + _toDisplayString(_ctx.monthLimitNextResetDate), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.store.getters.getAppData?.requisitesTotalLimitEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, _toDisplayString(_ctx.$t("labels.total_sum")), 1),
                    _createElementVNode("div", _hoisted_155, [
                      _createVNode(_component_FormInputWrapper, {
                        field: "totalTradesSumLimit",
                        form: "requisitesForm"
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.totalTradesSumLimit) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "data-maska": "9 99#",
                            "data-maska-tokens": "9:[0-9]:repeated",
                            "data-maska-reversed": "",
                            type: "text",
                            id: "totalTradesSumLimit"
                          }, null, 2), [
                            [_vModelText, _ctx.form.totalTradesSumLimit],
                            [_directive_maska]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.form.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.totalTradesSum)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.$t("labels.total_qty")), 1),
                    _createElementVNode("div", _hoisted_159, [
                      _createVNode(_component_FormInputWrapper, {
                        field: "totalTradesCountLimit",
                        form: "requisitesForm"
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.totalTradesCountLimit) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "data-maska": "9 99#",
                            "data-maska-tokens": "9:[0-9]:repeated",
                            "data-maska-reversed": "",
                            type: "text",
                            required: "",
                            id: "totalTradesCountLimit"
                          }, null, 2), [
                            [_vModelText, _ctx.form.totalTradesCountLimit],
                            [_directive_maska]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.form.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(_ctx.$t("labels.current")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.form.totalTradesCount)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.$t('labels.manual_reset_enabled')), 1),
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("label", _hoisted_164, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.manualResetEnabled) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.manualResetEnabled]
                        ]),
                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "slider" }, null, -1))
                      ])
                    ])
                  ]),
                  (_ctx.form.id && _ctx.form.manualResetEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                        _createVNode(_component_LoaderButton, {
                          "on-click": () => _ctx.resetLimits('total'),
                          class: "btn btn-outline-primary btn-sm flex-0_5"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.$t('button.reset_total_limit')), 1)
                          ]),
                          _: 1
                        }, 8, ["on-click"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_167, [
            (_ctx.form.maxReuseCountEnable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, _toDisplayString(_ctx.$t("labels.maxReuseCount")), 1),
                  _createElementVNode("div", _hoisted_170, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "maxReuseCount",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.maxReuseCount) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": "",
                          type: "text",
                          required: "",
                          id: "maxReuseCount"
                        }, null, 2), [
                          [_vModelText, _ctx.form.maxReuseCount],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.maxReuseCountEnable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                  _createElementVNode("div", _hoisted_172, _toDisplayString(_ctx.$t("labels.reuseDaysCount")), 1),
                  _createElementVNode("div", _hoisted_173, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "reuseDaysCount",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.reuseDaysCount) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": "",
                          type: "text",
                          required: "",
                          id: "reuseDaysCount"
                        }, null, 2), [
                          [_vModelText, _ctx.form.reuseDaysCount],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.maxReuseCountEnable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                  _createElementVNode("div", _hoisted_175, _toDisplayString(_ctx.$t("labels.reusablePaymentsCountLimit")), 1),
                  _createElementVNode("div", _hoisted_176, [
                    (!_ctx.store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled)
                      ? (_openBlock(), _createBlock(_component_FormInputWrapper, {
                          key: 0,
                          field: "reusablePaymentsCountLimit",
                          form: "requisitesForm"
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.reusablePaymentsCountLimit) = $event)),
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "data-maska": "9 99#",
                              "data-maska-tokens": "9:[0-9]:repeated",
                              "data-maska-reversed": "",
                              type: "text",
                              required: "",
                              id: "reusablePaymentsCountLimit"
                            }, null, 2), [
                              [_vModelText, _ctx.form.reusablePaymentsCountLimit],
                              [_directive_maska]
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          value: _ctx.store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11,
                          disabled: "",
                          type: "text",
                          class: "form-control form-control--disabled",
                          id: "reusablePaymentsCountLimit"
                        }, null, 8, _hoisted_177))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.templateMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.$emit('show-counterparties', _ctx.form.id))),
                      class: "btn btn-outline-primary btn-sm text-capitalize-first"
                    }, _toDisplayString(_ctx.$t('button.counterparties')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_180, [
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("div", _hoisted_182, _toDisplayString(_ctx.$t('labels.onlyInternalTransfer')), 1),
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("label", _hoisted_184, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.onlyInternalTransfer) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.onlyInternalTransfer]
                  ]),
                  _cache[51] || (_cache[51] = _createElementVNode("span", { class: "slider" }, null, -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_185, [
            _createElementVNode("div", _hoisted_186, [
              _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.$t('labels.farmsSettings')), 1),
              _createElementVNode("div", _hoisted_188, [
                _createElementVNode("label", _hoisted_189, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.isFarmsSettingsEnabled) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isFarmsSettingsEnabled]
                  ]),
                  _cache[52] || (_cache[52] = _createElementVNode("span", { class: "slider" }, null, -1))
                ])
              ])
            ]),
            (!_ctx.templateMode && !_ctx.form.id && _ctx.store.getters.getAppData?.fraudexEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                  _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.$t('labels.white_triangle')), 1),
                  _createElementVNode("div", _hoisted_192, [
                    _createElementVNode("label", _hoisted_193, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.isWhiteTriangle) = $event)),
                        onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.handleWhiteTriangleChange && _ctx.handleWhiteTriangleChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.form.isWhiteTriangle]
                      ]),
                      _cache[53] || (_cache[53] = _createElementVNode("span", { class: "slider" }, null, -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.form.isFarmsSettingsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                (_ctx.form.isFarmsSettingsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                      _createElementVNode("div", _hoisted_196, _toDisplayString(_ctx.$t("labels.concurrent_trader_count")), 1),
                      _createElementVNode("div", _hoisted_197, [
                        _createVNode(_component_FormInputWrapper, {
                          field: "concurrentTradesCount",
                          form: "requisitesForm"
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.concurrentTradesCount) = $event)),
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "data-maska": "9 99#",
                              "data-maska-tokens": "9:[0-9]:repeated",
                              "data-maska-reversed": "",
                              type: "text",
                              id: "concurrentTradesCount"
                            }, null, 2), [
                              [_vModelText, _ctx.form.concurrentTradesCount],
                              [_directive_maska]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.isFarmsSettingsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                      _createElementVNode("div", _hoisted_199, _toDisplayString(_ctx.$t("labels.trades_timeout_minutes")), 1),
                      _createElementVNode("div", _hoisted_200, [
                        _createVNode(_component_FormInputWrapper, {
                          field: "tradesTimeoutMinutes",
                          form: "requisitesForm"
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.tradesTimeoutMinutes) = $event)),
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "data-maska": "9 99#",
                              "data-maska-tokens": "9:[0-9]:repeated",
                              "data-maska-reversed": "",
                              type: "text",
                              id: "tradesTimeoutMinutes"
                            }, null, 2), [
                              [_vModelText, _ctx.form.tradesTimeoutMinutes],
                              [_directive_maska]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.templateMode && _ctx.form.method && _ctx.blacklistMethods.includes(_ctx.form.method))
            ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                _createVNode(_component_FormInputWrapper, {
                  field: "isAgreeBlacklistPaymentMethod",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["", parentProps.class]),
                      role: "alert"
                    }, [
                      _createElementVNode("div", _hoisted_202, [
                        _withDirectives(_createElementVNode("input", {
                          class: "",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.isAgreeBlacklistPaymentMethod) = $event)),
                          type: "checkbox",
                          value: "",
                          id: "isAgreeBlacklistPaymentMethod"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.isAgreeBlacklistPaymentMethod]
                        ]),
                        _createElementVNode("label", _hoisted_203, _toDisplayString(_ctx.$t('labels.agree_with_risk')), 1)
                      ])
                    ], 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_204, [
            _createElementVNode("button", {
              class: "btn",
              type: "button",
              onClick: _cache[45] || (_cache[45] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_205, _toDisplayString(_ctx.$t('button.cancel')), 1)
            ]),
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.save,
              class: "btn btn--accept"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_206, _toDisplayString(_ctx.$t('button.save')), 1)
              ]),
              _: 1
            }, 8, ["on-click"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "onOnClose"]),
    (_ctx.store.getters.getAppData?.fraudexEnabled)
      ? (_openBlock(), _createBlock(_component_FraudexCheckPopup, {
          key: 0,
          ref: (el) => _ctx.fraudexCheckPopup = el,
          fraudexCheck: _ctx.fraudexCheckData || null,
          onContinue: _ctx.handleFraudexCheckContinue,
          onCancel: _ctx.handleFraudexCheckCancel
        }, null, 8, ["fraudexCheck", "onContinue", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}